document.addEventListener("DOMContentLoaded", () => {
  const productList = document.querySelector(".boost-sd__filter-product-list.boost-sd__filter-product-list--ready"); //Boost #233340
  
  if (!productList) {
      console.error("Product list not found!");
  } else {
      const config = { childList: true };
  
      const callback = (mutationList, observer) => {
          try {
              for (const mutation of mutationList) {
                  if (mutation.target === productList) {
                    if (mutation.target.querySelector('.boost-sd__product-list')) {
                        const gridItem = mutation.target.querySelector('.boost-sd__product-list');
                        const swatchElms = gridItem.querySelectorAll('.variant-home');
                        if (swatchElms && swatchElms.length > 0) {
                            swatchElms.forEach(function(swatch) {
                                swatch.addEventListener('click', function(e) {
                                    e.preventDefault();
                                    e.stopPropagation();
                                    e.stopImmediatePropagation();
                                    const target = e.target;
                                    const variantUrl = target.hasAttribute('data-href') ? target.getAttribute('data-href') : target.getAttribute('href');
                                    console.log('variant URL: ', variantUrl);
                                    window.location.href = variantUrl;
                                })
                            })
                        }
                    }
                  }
              }
          } catch (error) {
              console.warn(error);
          }
      };
  
      const observer = new MutationObserver(callback);
  
      try {
          observer.observe(productList, config);
      } catch (error) {
          console.error("Observer failed");
      }
  }
});

